import { Action, configureStore } from "@reduxjs/toolkit";
import { ThunkAction } from "redux-thunk";
import userReducer from "./user/user-reducer";
import assignedReducer from "./assigned/assigned-reducer";
import documentsReducer from "./documents/documents-reducer";
import authReducer from "./auth/auth-reducer";

const store = configureStore({
    reducer: {
        auth: authReducer,
        documents: documentsReducer,
        assigned: assignedReducer,
        user: userReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, unknown, Action>;

export default store;
